import Swal from 'sweetalert2';

const defaultConfirm = 'OK';

const baseCustomClass = {
  popup: 'rrpl-feedback-modal',
  confirmButton: 'btn rrpl-feedback-confirm',
  cancelButton: 'btn btn-outline-secondary rrpl-feedback-cancel',
};

/**
 * Extrai mensagem legível de erros Axios / FastAPI (detail string ou lista de validação).
 */
export function parseApiError(error) {
  const d = error?.response?.data?.detail;
  if (typeof d === 'string') return d;
  if (Array.isArray(d) && d.length) {
    return d.map((x) => x.msg || JSON.stringify(x)).join(' ');
  }
  if (error?.code === 'ECONNABORTED') {
    return 'O pedido demorou demasiado. Tenta novamente.';
  }
  if (error?.message === 'Network Error') {
    return 'Sem ligação ao servidor. Verifica a rede ou se a API está disponível.';
  }
  const status = error?.response?.status;
  if (status === 401) return 'Credenciais inválidas ou sessão expirada.';
  if (status === 403) return 'Não tens permissão para esta operação.';
  if (status === 404) return 'Recurso não encontrado.';
  if (status >= 500) return 'Erro no servidor. Tenta mais tarde.';
  return 'Ocorreu um erro inesperado.';
}

function normalizePayload(payload) {
  if (payload == null) return {};
  if (typeof payload === 'string') return { text: payload };
  return payload;
}

/**
 * Modal padrão de sucesso (SweetAlert2).
 * @param {string|object} payload — texto ou { title, text, html, timer, showConfirmButton, ... }
 */
export function showSuccessModal(payload) {
  const opts = normalizePayload(payload);
  const {
    title = 'Sucesso',
    text,
    html,
    confirmButtonText = defaultConfirm,
    ...rest
  } = opts;
  return Swal.fire({
    icon: 'success',
    title,
    text: html ? undefined : text,
    html,
    confirmButtonText,
    buttonsStyling: false,
    showCloseButton: true,
    customClass: {
      ...baseCustomClass,
      confirmButton: 'btn btn-success rrpl-feedback-confirm',
    },
    ...rest,
  });
}

/**
 * Modal padrão de erro.
 */
export function showErrorModal(payload) {
  const opts = normalizePayload(payload);
  const {
    title = 'Erro',
    text,
    html,
    confirmButtonText = defaultConfirm,
    ...rest
  } = opts;
  return Swal.fire({
    icon: 'error',
    title,
    text: html ? undefined : text,
    html,
    confirmButtonText,
    buttonsStyling: false,
    showCloseButton: true,
    customClass: {
      ...baseCustomClass,
      confirmButton: 'btn rrpl-feedback-confirm rrpl-feedback-confirm--danger',
    },
    ...rest,
  });
}

/**
 * Modal informativo (opcional, mesmo padrão visual).
 */
export function showInfoModal(payload) {
  const opts = normalizePayload(payload);
  const {
    title = 'Informação',
    text,
    html,
    confirmButtonText = defaultConfirm,
    ...rest
  } = opts;
  return Swal.fire({
    icon: 'info',
    title,
    text: html ? undefined : text,
    html,
    confirmButtonText,
    buttonsStyling: false,
    showCloseButton: true,
    customClass: {
      ...baseCustomClass,
      confirmButton: 'btn btn-primary rrpl-feedback-confirm',
    },
    ...rest,
  });
}

/**
 * Modal de aviso.
 */
export function showWarningModal(payload) {
  const opts = normalizePayload(payload);
  const {
    title = 'Atenção',
    text,
    html,
    confirmButtonText = defaultConfirm,
    ...rest
  } = opts;
  return Swal.fire({
    icon: 'warning',
    title,
    text: html ? undefined : text,
    html,
    confirmButtonText,
    buttonsStyling: false,
    showCloseButton: true,
    customClass: {
      ...baseCustomClass,
      confirmButton: 'btn btn-warning rrpl-feedback-confirm',
    },
    ...rest,
  });
}

export function closeFeedbackModals() {
  Swal.close();
}
